var _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipse01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 782,
    height: 782,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390.55,
    cy: 390.551,
    r: 285.903,
    transform: "rotate(30 390.55 390.551)",
    fill: "url(#ellipse-01_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ellipse-01_svg__paint0_linear",
    x1: 606.2,
    y1: 318.075,
    x2: 349.199,
    y2: 531.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzgyIiBoZWlnaHQ9Ijc4MiIgdmlld0JveD0iMCAwIDc4MiA3ODIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjM5MC41NSIgY3k9IjM5MC41NTEiIHI9IjI4NS45MDMiIHRyYW5zZm9ybT0icm90YXRlKDMwIDM5MC41NSAzOTAuNTUxKSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iNjA2LjIiIHkxPSIzMTguMDc1IiB4Mj0iMzQ5LjE5OSIgeTI9IjUzMS41MDIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0Y1RjlGQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgEllipse01 as ReactComponent };